import { qrcodegen } from '../vendor/qrcodegen';

const QrCode = qrcodegen.QrCode;

/** Render `text` as a QR code onto a canvas at the given pixel size (dark theme: white modules on black). */
export function drawQR(canvas: HTMLCanvasElement, text: string, size = 260): void {
  const qr = QrCode.encodeText(text, QrCode.Ecc.MEDIUM);
  const dpr = Math.min(2, window.devicePixelRatio || 1);
  canvas.width = Math.round(size * dpr);
  canvas.height = Math.round(size * dpr);
  canvas.style.width = `${size}px`;
  canvas.style.height = `${size}px`;
  const ctx = canvas.getContext('2d')!;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  const border = 2;
  const n = qr.size + border * 2;
  const scale = size / n;
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, size, size);
  ctx.fillStyle = '#000';
  for (let y = 0; y < qr.size; y++) {
    for (let x = 0; x < qr.size; x++) {
      if (qr.getModule(x, y)) ctx.fillRect((x + border) * scale, (y + border) * scale, scale + 0.5, scale + 0.5);
    }
  }
}
